export enum UserPanelTabId {
	ITINERARY = 'itinerary',
	CART = 'cart',
	FOR_YOU = 'for-you',
}
